var _defs, _rect, _rect2, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreamGauge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    height: 21,
    width: 21,
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title92"
  }, "airport.svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title92"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 21,
    height: 21,
    id: "rect94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21,
    height: 21,
    rx: 10.5,
    ry: 10.5,
    fill: "#ffffff",
    id: "rect96"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-02",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 12.1,-17.5 a 1,0.64999998 0 0 0 1,0.650391 1,0.64999998 0 0 0 1,-0.650391 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 14,-17.5 a 1,0.64999998 0 0 0 1,0.650391 A 1,0.64999998 0 0 0 16,-17.5 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m -1.0654834,10.084141 v 1.6818 l -6.4999999,-1 -0.3182,4.7727 2.8182,1.7273 v 1 l -3.5,-0.6818 -3.4999997,0.6818 v -1 l 2.8181997,-1.7273 -0.3182,-4.7727 -6.4999997,1 v -1.6818 l 6.4999997,-2.3182002 v -3 c 0,0 0,-1.5 1,-1.5 1,0 1,1.5 1,1.5 v 2.8182 z",
    id: "path98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.034237
    },
    d: "m -22.125776,8.7749971 8e-4,-0.4999971 -0.4928,0.00239 c -0.4589,0.00222 -0.5846,-0.00653 -0.4643,0.036804 0.3259,0.117338 0.7313,0.426328 0.8734,0.765162 l 0.082,0.195639 z",
    id: "path688-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.034237
    },
    d: "M -31.625821,8.7749971 -31.625,8.275 -32.117754,8.27739 c -0.458903,0.00222 -0.584656,-0.00653 -0.464297,0.036804 0.325861,0.117338 0.731206,0.426328 0.873341,0.765162 l 0.08207,0.195639 z",
    id: "path688-3-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0357387
    },
    d: "M -29.124106,8.7749974 -29.125,8.275 l 0.536927,0.00239 c 0.500046,0.00222 0.527255,0.00559 0.396106,0.048924 -0.355074,0.1173429 -0.686942,0.4142131 -0.84182,0.7530471 L -29.123212,9.275 Z",
    id: "path688"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.034237
    },
    d: "M -19.624179,8.7749974 -19.625,8.275 l 0.492754,0.00239 c 0.458903,0.00222 0.584656,-0.00653 0.464297,0.036804 -0.325861,0.1173383 -0.731206,0.4263279 -0.873341,0.7651623 l -0.08207,0.1956392 z",
    id: "path688-3"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 0.86594,
      imageRendering: "auto"
    },
    id: "rect470",
    width: 2.5,
    height: 9,
    x: -31.625,
    y: 8.1750002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 0.86594
    },
    id: "rect472",
    width: 2.5,
    height: 9,
    x: -22.125,
    y: 8.1750002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 1.03077
    },
    id: "rect611",
    width: 17,
    height: 1.2,
    x: -34.125,
    y: 7.0749998
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7194",
    style: {
      display: "inline"
    },
    transform: "translate(19.804289,-32.742881)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0554599,
      strokeDasharray: "none"
    },
    id: "rect4784-8",
    width: 2.0999999,
    height: 13,
    x: 25.104929,
    y: 2.5214548
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0450334,
      strokeDasharray: "none"
    },
    id: "rect5685-7",
    width: 1.2,
    height: 0.30000001,
    x: 26.004929,
    y: 4.0214548
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0450334,
      strokeDasharray: "none"
    },
    id: "rect5685-9-1",
    width: 1.2,
    height: 0.30000001,
    x: 26.004929,
    y: 6.4214544
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0450334,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-7",
    width: 1.2,
    height: 0.30000001,
    x: 26.004929,
    y: 8.821455
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0450334,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-2",
    width: 1.2,
    height: 0.30000001,
    x: 26.004929,
    y: 11.221455
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0450334,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-9-7",
    width: 1.2,
    height: 0.30000001,
    x: 26.004929,
    y: 13.621455
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    id: "path1161-3-22-1-6-3",
    cx: 23.437916,
    cy: 24.139078,
    rx: 2.25,
    ry: 1.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#49ad54",
      fillOpacity: 1,
      strokeWidth: 0.937669,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6-0-1-6",
    cx: 23.437916,
    cy: 24.139078,
    rx: 1.75,
    ry: 1.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "M 6.75 30.125 A 1.75 1.05 0 0 1 5 31.173828 L 5 31.875 A 2.25 1.75 0 0 0 7.25 30.125 L 6.75 30.125 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "M 7.7499999,30.125 A 2.25,1.75 0 0 0 10,31.875 a 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 A 1.75,1.05 0 0 1 10,31.173828 1.75,1.05 0 0 1 8.2499999,30.125 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "M 12.75 30.125 A 2.25 1.75 0 0 0 15 31.875 L 15 31.173828 A 1.75 1.05 0 0 1 13.25 30.125 L 12.75 30.125 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 3.625,32.25 a 1.75,1.05 0 0 1 -1.75,1.048828 V 34 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "M 7.6249999,32.25 A 2.25,1.75 0 0 0 9.8750001,34 2.25,1.75 0 0 0 12.125,32.25 h -0.5 A 1.75,1.05 0 0 1 9.8750001,33.298828 1.75,1.05 0 0 1 8.1249999,32.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 3.625,32.25 a 2.25,1.75 0 0 0 2.2500001,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 A 1.75,1.05 0 0 1 4.1249999,32.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 15.625,32.25 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 A 1.75,1.05 0 0 1 17.875,33.298828 1.75,1.05 0 0 1 16.125,32.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-9",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "M 11.625,32.25 A 2.25,1.75 0 0 0 13.875001,34 2.25,1.75 0 0 0 16.125,32.25 h -0.5 A 1.75,1.05 0 0 1 13.875001,33.298828 1.75,1.05 0 0 1 12.125,32.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "M 19.625,32.25 A 2.25,1.75 0 0 0 21.875,34 V 33.298828 A 1.75,1.05 0 0 1 20.125,32.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-2",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 3.6249998,34.923401 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-0",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 7.6249997,34.923401 a 2.25,1.75 0 0 0 2.2500002,1.75 2.25,1.75 0 0 0 2.2500001,-1.75 h -0.5 A 1.75,1.05 0 0 1 9.8749999,35.972229 1.75,1.05 0 0 1 8.1249997,34.923401 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-2",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 3.6249998,34.923401 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.2500001,-1.75 H 7.6249998 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.7500001,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-3",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 15.625,34.923401 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-9-7",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 11.625,34.923401 a 2.25,1.75 0 0 0 2.250001,1.75 2.25,1.75 0 0 0 2.249999,-1.75 h -0.5 A 1.75,1.05 0 0 1 13.875001,35.972229 1.75,1.05 0 0 1 12.125,34.923401 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-5",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 19.625,34.923401 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    id: "path1161-3-22-1-6-3-0",
    cx: 23.499491,
    cy: 27.75,
    rx: 2.25,
    ry: 1.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#49ad54",
      fillOpacity: 1,
      strokeWidth: 0.937669,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6-0-1-6-9",
    cx: 23.499491,
    cy: 27.75,
    rx: 1.75,
    ry: 1.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 39.913554,-26.837449 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 43.913555,-26.837449 a 2.25,1.75 0 0 0 2.250001,1.75 2.25,1.75 0 0 0 2.249999,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.749999,1.048828 1.75,1.05 0 0 1 -1.750001,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 39.913554,-26.837449 a 2.25,1.75 0 0 0 2.250001,1.75 2.25,1.75 0 0 0 2.250001,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.750001,1.048828 1.75,1.05 0 0 1 -1.750001,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 47.913229,-26.837449 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 51.913229,-26.837449 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 39.91032,-27.421426 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 43.91032,-27.421426 a 2.25,1.75 0 0 0 2.250001,1.75 2.25,1.75 0 0 0 2.249999,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.749999,1.048828 1.75,1.05 0 0 1 -1.750001,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 39.91032,-27.421426 a 2.25,1.75 0 0 0 2.250001,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.750001,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 47.909995,-27.421426 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.249999,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 51.909994,-27.421426 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 11.125,38.75 a 1.75,1.05 0 0 1 -1.75,1.048828 V 40.5 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 11.125,38.75 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 A 1.75,1.05 0 0 1 13.375,39.798828 1.75,1.05 0 0 1 11.625,38.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 15.125,38.75 a 2.25,1.75 0 0 0 2.25,1.75 V 39.798828 A 1.75,1.05 0 0 1 15.625,38.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 38.159218,-21.971426 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 38.159218,-21.971426 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 42.159218,-21.971426 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 49.159218,-21.971426 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-5",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 49.159218,-21.971426 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-5",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 53.159218,-21.971426 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 11.208209,41.244132 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 11.208209,41.244132 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.37266,
      fillOpacity: 1
    },
    d: "m 15.208209,41.244132 a 2.25,1.75 0 0 0 2.25,1.75 V 42.29296 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11806",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 38.159218,-21.971426 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11808",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 38.159218,-21.971426 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11810",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 42.159218,-21.971426 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(-0.67733121,0.21776896)"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 1.19322
    },
    id: "path617",
    cx: -14.959525,
    cy: 4.305562,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161",
    style: {
      fill: "#000000",
      strokeWidth: 0.489146
    },
    d: "m 4.6808949,-5.1111622 a 1,0.5 0 0 0 1,0.5 1,0.5 0 0 0 1,-0.5 H 6.4816761 A 0.80000001,0.30000001 0 0 1 5.6808949,-4.810381 0.80000001,0.30000001 0 0 1 4.8801137,-5.1111622 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.489146
    },
    d: "m 6.4808949,-5.1111622 a 1,0.5 0 0 0 1,0.5 1,0.5 0 0 0 1,-0.5 H 8.2816761 A 0.80000001,0.30000001 0 0 1 7.4808949,-4.810381 0.80000001,0.30000001 0 0 1 6.6801137,-5.1111622 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-5",
    style: {
      fill: "#000000",
      strokeWidth: 0.489146
    },
    d: "m 8.2808949,-5.1111622 a 1,0.5 0 0 0 1,0.5 1,0.5 0 0 0 1.0000001,-0.5 H 10.081676 A 0.80000001,0.30000001 0 0 1 9.2808949,-4.810381 0.80000001,0.30000001 0 0 1 8.4801137,-5.1111622 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-7-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.489146
    },
    d: "m 10.080895,-5.1111622 a 1,0.5 0 0 0 1,0.5 1,0.5 0 0 0 1,-0.5 h -0.199219 a 0.80000001,0.30000001 0 0 1 -0.800781,0.3007812 0.80000001,0.30000001 0 0 1 -0.800781,-0.3007812 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-56",
    style: {
      fill: "#000000",
      strokeWidth: 0.489145
    },
    d: "m 4.3619207,-1.7897842 a 1,0.5 0 0 0 1,0.5 1,0.5 0 0 0 1,-0.5 H 6.1627019 a 0.80000001,0.30000001 0 0 1 -0.8007812,0.300781 0.80000001,0.30000001 0 0 1 -0.8007812,-0.300781 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-7-2",
    style: {
      fill: "#000000",
      strokeWidth: 0.489145
    },
    d: "m 6.1619207,-1.7897842 a 1,0.5 0 0 0 1,0.5 1,0.5 0 0 0 1.0000003,-0.5 H 7.962702 a 0.80000001,0.30000001 0 0 1 -0.8007813,0.300781 0.80000001,0.30000001 0 0 1 -0.8007812,-0.300781 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-5-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.489145
    },
    d: "m 7.961921,-1.7897842 a 1,0.5 0 0 0 1,0.5 1,0.5 0 0 0 1,-0.5 H 9.762702 a 0.80000001,0.30000001 0 0 1 -0.800781,0.300781 0.80000001,0.30000001 0 0 1 -0.800781,-0.300781 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-7-3-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.489145
    },
    d: "m 9.761921,-1.7897842 a 1,0.5 0 0 0 1,0.5 1,0.5 0 0 0 1,-0.5 h -0.199219 a 0.80000001,0.30000001 0 0 1 -0.800781,0.300781 0.80000001,0.30000001 0 0 1 -0.800782,-0.300781 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-8-9-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 15.9,-17.5 a 1,0.64999998 0 0 0 1,0.650391 V -17 a 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-8-9-9-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 17,-13 a 1,0.64999998 0 0 0 1,0.650391 V -12.5 A 0.89999998,0.5 0 0 1 17.099609,-13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-8-9-9-1-2",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 7.7000002,-13 a 1,0.64999998 0 0 0 1,0.650391 V -12.5 A 0.89999998,0.5 0 0 1 7.7996092,-13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-6-2-8-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "M 6.40039,-17.5 A 0.89999982,0.5 0 0 1 5.5,-17 v 0.150391 A 0.99999982,0.64999998 0 0 0 6.5,-17.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-6-2-8-7-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "M 3.90039,-13 A 0.89999982,0.5 0 0 1 3,-12.5 v 0.15039 A 0.99999982,0.64999998 0 0 0 4,-13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-6-2-8-7-3-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "M 13.20039,-13 A 0.89999982,0.5 0 0 1 12.3,-12.5 v 0.15039 A 0.99999982,0.64999998 0 0 0 13.3,-13 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000",
      strokeWidth: 0.489146
    },
    id: "path1161-3",
    cx: -32.982548,
    cy: 6.0287619,
    rx: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#49ad54",
      fillOpacity: 1,
      strokeWidth: 0.338877,
      strokeDasharray: "none"
    },
    id: "path1161-5-6",
    cx: -32.982548,
    cy: 6.0287619,
    rx: 0.80000001,
    ry: 0.30000001
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 0.691758
    },
    id: "path1161-3-22",
    cx: 31,
    cy: 31.048004,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49ad54",
      fillOpacity: 1,
      strokeWidth: 0.415036,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6",
    cx: 31,
    cy: 31.048004,
    r: 0.60000002
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 35 31 A 1.25 1 0 0 0 36.25 32 A 1.25 1 0 0 0 37.5 31 L 37.25 31 A 1 0.60000002 0 0 1 36.25 31.599609 A 1 0.60000002 0 0 1 35.25 31 L 35 31 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 5 22.283203 A 1.25 1 0 0 0 6.25 23.283203 L 6.25 22.882812 A 1 0.60000002 0 0 1 5.25 22.283203 L 5 22.283203 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 8.0848016,22.335685 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.2500004,-1 h -0.25 a 1,0.60000002 0 0 1 -1.0000004,0.599609 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.773409,
      fillOpacity: 1
    },
    d: "M 5.5,24 A 1.25,1 0 0 0 6.75,25 1.25,1 0 0 0 8,24 H 7.75 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 5.75,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "M 7.75,24 A 1.25,1 0 0 0 9,25 1.25,1 0 0 0 10.250001,24 h -0.25 A 1,0.60000002 0 0 1 9,24.599609 1,0.60000002 0 0 1 8,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 10,24 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 10.25,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 12.25,24 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 H 14.5 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 12.5,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8-5-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 14.5,24 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 14.75,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 13.25 22.333984 A 1 0.60000002 0 0 1 12.25 22.933594 L 12.25 23.333984 A 1.25 1 0 0 0 13.5 22.333984 L 13.25 22.333984 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "M 16.75,24 A 1.25,1 0 0 0 18,25 V 24.599609 A 1,0.60000002 0 0 1 17,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-93",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 5.5,24 a 1,0.60000002 0 0 1 -1,0.59961 V 25 a 1.25,1 0 0 0 1.25,-1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-97",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 7,-23.6 a 1.25,1 0 0 0 1.25,1 v -0.400391 A 1,0.60000002 0 0 1 7.25,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 2.4999995,-23.6 A 1.25,1 0 0 0 3.75,-22.6 1.25,1 0 0 0 5,-23.6 H 4.75 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 2.7499995,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 4.7499995,-23.6 A 1.25,1 0 0 0 6,-22.6 a 1.25,1 0 0 0 1.25,-1 H 7 A 1,0.60000002 0 0 1 6,-23.000391 1,0.60000002 0 0 1 4.9999995,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 2.5,-23.6 a 1,0.60000002 0 0 1 -1,0.59961 V -22.6 a 1.25,1 0 0 0 1.25,-1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-97-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 18.5,-23.6 a 1.25,1 0 0 0 1.25,1 v -0.400391 A 1,0.60000002 0 0 1 18.75,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 13.999999,-23.6 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 14.249999,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-6-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 11.75,-23.6 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 H 14 A 1,0.60000002 0 0 1 13,-23.000391 1,0.60000002 0 0 1 12,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-7-5",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 16.249999,-23.6 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 H 18.5 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 16.499999,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-6-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 11.75,-23.6 a 1,0.60000002 0 0 1 -1,0.59961 V -22.6 a 1.25,1 0 0 0 1.25,-1 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    id: "path1161-3-22-1-6",
    cx: 36.25,
    cy: 34,
    rx: 1.25,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#49ad54",
      fillOpacity: 1,
      strokeWidth: 0.535809,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6-0-1",
    cx: 36.25,
    cy: 34,
    rx: 1,
    ry: 0.60000002
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "M -21 1.6503906 A 1 0.64999998 0 0 0 -20 2.3007812 A 1 0.64999998 0 0 0 -19 1.6503906 L -19.099609 1.6503906 A 0.89999998 0.5 0 0 1 -20 2.1503906 A 0.89999998 0.5 0 0 1 -20.900391 1.6503906 L -21 1.6503906 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 6.4000002,-17.5 a 1,0.64999998 0 0 0 1,0.650391 1,0.64999998 0 0 0 1,-0.650391 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 8.3000002,-17.5 a 1,0.64999998 0 0 0 1,0.650391 A 1,0.64999998 0 0 0 10.3,-17.5 h -0.09961 a 0.89999998,0.5 0 0 1 -0.9003908,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 10.2,-17.5 a 1,0.64999998 0 0 0 1,0.650391 1,0.64999998 0 0 0 1,-0.650391 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5924-5",
    transform: "translate(12.53598,4.3752232)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect4784-4-2",
    width: 2,
    height: 12,
    x: 24.500038,
    y: -1.6689709
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-7-5",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: -0.668971
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-8-4",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: 1.7310287
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-4-7",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: 4.1310291
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-5-4",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: 6.5310287
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-9-0-4",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: 8.9310293
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 35.836018,6.6115528 a 1,0.64999998 0 0 0 1,0.6503906 1,0.64999998 0 0 0 1,-0.6503906 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-6-0",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 37.736018,6.6115528 a 1,0.64999998 0 0 0 1,0.6503906 1,0.64999998 0 0 0 1,-0.6503906 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-62",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 3.9000002,-13 a 1,0.64999998 0 0 0 1,0.65039 A 1,0.64999998 0 0 0 5.9000001,-13 h -0.09961 a 0.89999998,0.5 0 0 1 -0.9003909,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 5.8000001,-13 a 1,0.64999998 0 0 0 1,0.65039 1,0.64999998 0 0 0 1,-0.65039 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 13.2,-13 a 1,0.64999998 0 0 0 1,0.65039 1,0.64999998 0 0 0 1,-0.65039 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 15.1,-13 a 1,0.64999998 0 0 0 1,0.65039 1,0.64999998 0 0 0 1,-0.65039 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-7-2",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 26.9,2 a 1,0.64999998 0 0 0 1,0.65039 A 1,0.64999998 0 0 0 28.9,2 H 28.80039 A 0.89999998,0.5 0 0 1 27.899999,2.5 0.89999998,0.5 0 0 1 26.999608,2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3-9-2",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 28.8,2 a 1,0.64999998 0 0 0 1,0.65039 A 1,0.64999998 0 0 0 30.8,2 H 30.70039 A 0.89999998,0.5 0 0 1 29.799999,2.5 0.89999998,0.5 0 0 1 28.899608,2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-97-39",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 14.72034,26.347961 a 1.25,1 0 0 0 1.25,1 V 26.94757 a 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-4",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 10.220339,26.347961 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1.000001,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-7-8",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 12.470339,26.347961 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1.000001,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-6-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 10.22034,26.347961 a 1,0.60000002 0 0 1 -1.0000005,0.59961 v 0.40039 a 1.25,1 0 0 0 1.2500005,-1 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-0",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 16,-28 a 1.25,1 0 0 0 1.25,1 v -0.400391 A 1,0.60000002 0 0 1 16.25,-28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 4.75,-28 a 1.25,1 0 0 0 1.2500001,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 5,-28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-1-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 7,-28 A 1.25,1 0 0 0 8.2500001,-27 1.25,1 0 0 0 9.5,-28 H 9.25 A 1,0.60000002 0 0 1 8.2500001,-27.400391 1,0.60000002 0 0 1 7.25,-28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-1-71",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 9.25,-28 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 H 11.5 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 9.5,-28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-1-7-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 11.5,-28 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 11.75,-28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-1-7-1-5",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 13.75,-28 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 H 16 A 1,0.60000002 0 0 1 15,-27.400391 1,0.60000002 0 0 1 14,-28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 4.75,-28 a 1,0.60000002 0 0 1 -1,0.59961 V -27 A 1.25,1 0 0 0 5,-28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 38.159218,-22.621426 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 38.159218,-22.621426 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 42.159218,-22.621426 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 49.159218,-22.621426 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 49.159218,-22.621426 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 53.159218,-22.621426 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer13",
    transform: "translate(0.25,-0.007922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 4.5,-28.392078 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 H 6.75 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 6.75,-28.392078 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.250001,-1 h -0.25 A 1,0.60000002 0 0 1 8,-27.792469 1,0.60000002 0 0 1 7,-28.392078 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 9,-28.392078 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8-5-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 11.25,-28.392078 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 H 13.5 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8-5-0-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 13.5,-28.392078 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-2-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 15.75,-28.392078 a 1.25,1 0 0 0 1.25,1 v -0.400391 a 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-93-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 4.5,-28.392078 a 1,0.60000002 0 0 1 -1,0.59961 v 0.40039 a 1.25,1 0 0 0 1.25,-1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 9,-28.792078 a 1.25,1 0 0 0 1.249999,1 v -0.400391 A 1,0.60000002 0 0 1 9.25,-28.792078 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-5",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 9,-28.792859 a 1,0.60000002 0 0 1 -0.75,0.580078 v 0.400391 a 1.25,1 0 0 0 1,-0.980469 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-97-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 6.75,-23.992078 a 1.25,1 0 0 0 1.25,1 v -0.400391 a 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 2.249999,-23.992078 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 H 4.5 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1.000001,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-7-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 4.499999,-23.992078 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 H 6.75 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1.000001,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-6-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 2.25,-23.992078 a 1,0.60000002 0 0 1 -1,0.59961 v 0.40039 a 1.25,1 0 0 0 1.25,-1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-97-3-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 18.25,-23.992078 a 1.25,1 0 0 0 1.25,1 v -0.40039 a 1,0.60000002 0 0 1 -1,-0.59961 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-6-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 13.749999,-23.992078 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 H 16 a 1,0.60000002 0 0 1 -1,0.59961 1,0.60000002 0 0 1 -1.000001,-0.59961 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-6-9-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 11.5,-23.992078 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.59961 1,0.60000002 0 0 1 -1,-0.59961 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-7-5-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 15.999999,-23.992078 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.59961 1,0.60000002 0 0 1 -1.000001,-0.59961 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-6-6-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 11.5,-23.992078 a 1,0.60000002 0 0 1 -1,0.59961 v 0.40039 a 1.25,1 0 0 0 1.25,-1 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect5682-4",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    d: "M 44.519531 1.5957031 A 0.89999998 0.5 0 0 1 43.800781 2.0859375 L 43.800781 2.234375 A 1 0.64999998 0 0 0 44.619141 1.5957031 L 44.519531 1.5957031 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4784-4-2-2",
    style: {
      display: "inline",
      fill: "#fefefe",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    d: "M 44.519531 1.5957031 A 1 0.64999998 0 0 0 45.519531 2.2460938 A 1 0.64999998 0 0 0 45.820312 2.2148438 L 45.820312 2.0664062 A 0.89999998 0.5 0 0 1 45.519531 2.0957031 A 0.89999998 0.5 0 0 1 44.619141 1.5957031 L 44.519531 1.5957031 z "
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-7-5-0",
    width: 1.2,
    height: 0.40000001,
    x: 44.619823,
    y: -1.3097866
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-8-4-6",
    width: 1.2,
    height: 0.40000001,
    x: 44.619823,
    y: 1.0902132
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-4-7-8",
    width: 1.2,
    height: 0.40000001,
    x: 44.619823,
    y: 3.4902136
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-5-4-9",
    width: 1.2,
    height: 0.40000001,
    x: 44.619823,
    y: 5.890213
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-9-0-4-2",
    width: 1.2,
    height: 0.40000001,
    x: 44.619823,
    y: 8.2902136
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-8-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 26.620035,-0.27732117 a 1,0.64999998 0 0 0 1,0.6503906 v -0.1503906 a 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-6-2-8",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 29.069814,-0.24781687 a 0.89999998,0.5 0 0 1 -0.90039,0.5 v 0.1503906 a 1,0.64999998 0 0 0 1,-0.6503906 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5682-4-5",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    d: "m 40.296751,-0.94759518 a 0.89999998,0.5 0 0 1 -0.71875,0.4902344 v 0.1484376 a 1,0.64999998 0 0 0 0.81836,-0.638672 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5682-4-5-4",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    d: "M 10.21875,-17.65 A 0.89999998,0.5 0 0 1 9.5,-17.159766 v 0.148438 A 1,0.64999998 0 0 0 10.31836,-17.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4784-4-2-2-0",
    style: {
      display: "inline",
      fill: "#fefefe",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    d: "m 10.2,-17.645 a 1,0.64999998 0 0 0 1,0.650391 1,0.64999998 0 0 0 0.300781,-0.03125 v -0.148438 A 0.89999998,0.5 0 0 1 11.2,-17.145 a 0.89999998,0.5 0 0 1 -0.90039,-0.5 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer5",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect4784",
    width: 2,
    height: 12,
    x: 25.921051,
    y: 5.4293394
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5682",
    width: 2,
    height: 12,
    x: 28.693171,
    y: 5.4010396
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer8"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0367696,
      strokeDasharray: "none"
    },
    id: "rect5685",
    width: 1.2,
    height: 0.2,
    x: 26.72105,
    y: 6.4293394
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0367696,
      strokeDasharray: "none"
    },
    id: "rect5685-9",
    width: 1.2,
    height: 0.2,
    x: 26.72105,
    y: 8.829339
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0367696,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3",
    width: 1.2,
    height: 0.2,
    x: 26.72105,
    y: 11.22934
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0367696,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1",
    width: 1.2,
    height: 0.2,
    x: 26.72105,
    y: 13.629339
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0367696,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-9",
    width: 1.2,
    height: 0.2,
    x: 26.72105,
    y: 16.029341
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8981",
    transform: "matrix(1.6666666,0,0,1.1805556,-5.0868171,-1.5280483)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0681042,
      strokeDasharray: "none"
    },
    id: "rect4784-0",
    width: 2.7,
    height: 15.247058,
    x: 6.6520905,
    y: 2.564935
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0927743,
      strokeDasharray: "none"
    },
    id: "rect5685-6",
    width: 1.95,
    height: 0.7835294,
    x: 7.4020905,
    y: 4.6825819
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0927743,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-0",
    width: 1.95,
    height: 0.7835294,
    x: 7.4020905,
    y: 9.7649345
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0927742,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-9-1",
    width: 1.95,
    height: 0.7835294,
    x: 7.4020905,
    y: 14.847287
  })), /*#__PURE__*/React.createElement("g", {
    id: "g11830",
    transform: "matrix(1.1,0,0,1.573,-0.5,-6.0378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12178",
    transform: "translate(-1.104294,-2.33465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11832",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 12.854294,13.616055 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11834",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 12.854294,13.616055 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11836",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 16.854294,13.616055 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11812",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 12.854294,12.966055 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11814",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 12.854294,12.966055 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11816",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 16.854294,12.966055 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12194",
    transform: "translate(-0.781453,-2.127138)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-4",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 14.031453,9.8771384 a 1.75,1.05 0 0 1 -1.75,1.0488276 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.7499996 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-3",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 14.031453,9.8771384 a 2.25,1.75 0 0 0 2.25,1.7499996 2.25,1.75 0 0 0 2.25,-1.7499996 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.0488276 1.75,1.05 0 0 1 -1.75,-1.0488276 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-0",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 18.031453,9.8771384 a 2.25,1.75 0 0 0 2.25,1.7499996 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.0488276 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 14.031453,9.2271384 a 1.75,1.05 0 0 1 -1.75,1.0488276 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.7499996 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 14.031453,9.2271384 a 2.25,1.75 0 0 0 2.25,1.7499996 2.25,1.75 0 0 0 2.25,-1.7499996 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.0488276 1.75,1.05 0 0 1 -1.75,-1.0488276 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 18.031453,9.2271384 a 2.25,1.75 0 0 0 2.25,1.7499996 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.0488276 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12186",
    transform: "translate(0.5899356,-1.782497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-8",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 3.1600644,13.063902 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-8",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 3.1600644,13.063902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-4",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 7.1600644,13.063902 a 2.25,1.75 0 0 0 2.25,1.75 V 14.11273 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 3.1600644,12.413902 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 3.1600644,12.413902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 7.1600644,12.413902 a 2.25,1.75 0 0 0 2.25,1.75 V 13.46273 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-1-9",
    style: {
      display: "none",
      fill: "#000000",
      strokeWidth: 1.13235
    },
    d: "M 7.813976,11.6189 A 1.830125,1.4641 0 0 0 9.6440994,13.083 V 12.496788 A 1.4641,0.87846002 0 0 1 8.1800007,11.6189 Z",
    transform: "translate(-0.5899356,0.313902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-5-2",
    style: {
      display: "none",
      fill: "#000000",
      strokeWidth: 1.13235
    },
    d: "m 7.813976,11.617757 a 1.4641,0.87846002 0 0 1 -1.0980754,0.849292 v 0.586214 a 1.830125,1.4641 0 0 0 1.4641001,-1.435506 z",
    transform: "translate(-0.5899356,0.313902)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14523",
    transform: "translate(-1.104294,-5.227212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14511",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 12.854294,13.616055 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14513",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 12.854294,13.616055 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14515",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 16.854294,13.616055 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14517",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 12.854294,12.966055 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14519",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 12.854294,12.966055 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14521",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 16.854294,12.966055 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14541",
    transform: "translate(0.5899356,-4.675059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14525",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 3.1600644,13.063902 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14527",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 3.1600644,13.063902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14529",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 7.1600644,13.063902 a 2.25,1.75 0 0 0 2.25,1.75 V 14.11273 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14531",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 3.1600644,12.413902 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14533",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 3.1600644,12.413902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14535",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 7.1600644,12.413902 a 2.25,1.75 0 0 0 2.25,1.75 V 13.46273 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14537",
    style: {
      display: "none",
      fill: "#000000",
      strokeWidth: 1.13235
    },
    d: "M 7.813976,11.6189 A 1.830125,1.4641 0 0 0 9.6440994,13.083 V 12.496788 A 1.4641,0.87846002 0 0 1 8.1800007,11.6189 Z",
    transform: "translate(-0.5899356,0.313902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14539",
    style: {
      display: "none",
      fill: "#000000",
      strokeWidth: 1.13235
    },
    d: "m 7.813976,11.617757 a 1.4641,0.87846002 0 0 1 -1.0980754,0.849292 v 0.586214 a 1.830125,1.4641 0 0 0 1.4641001,-1.435506 z",
    transform: "translate(-0.5899356,0.313902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamGauge);
export default __webpack_public_path__ + "static/media/stream-gauge.145141c4080627a113e0b8ccec2fc964.svg";
export { ForwardRef as ReactComponent };